import {   Component, ElementRef,  EventEmitter,  OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {MenuItem, SelectItem, TreeNode} from 'primeng/api';
import { DashboardService } from 'src/app/_services/dashboard/dashboard.service';

import { ApiService } from 'src/app/_services/api.service';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { EChartsOption } from 'echarts';

import { GlobalService } from 'src/app/_services/global.service';
import { JavaRedirectComponent } from '../../java-redirect/java-redirect.component';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit {
  @ViewChild(JavaRedirectComponent)
  private javarComponent!: JavaRedirectComponent;

  actionLogin='arkiman/login/LogonServletMAN?oper=1';
  resfreshingKPI:boolean=false;
  breadcrumbs: MenuItem[];
  listaNews=[];
  listasegnalazioniric=[];
  listasegnalazioniinv=[];
  alberodocumenti: TreeNode[];
  countDocDaLeggere:number=0;
  ticketapertiperstruttura={};
  chartOption: EChartsOption;

  smallUnoTitle: string;
  smallUno: any[] = [];
  smallDueTitle: string;
  smallDue: any[] = [];
  smallTreTitle: string;
  smallTre: any[] = [];
 
  @ViewChild('autologinform') loginform:ElementRef;
  @ViewChild('usrname') usrname:ElementRef;
  @ViewChild('pwd') pwd:ElementRef;
  
  @Output() messageEvent = new EventEmitter<any>();
  
  constructor(
    private translate: TranslateService,
    public dashboardService: DashboardService,
    private apiService: ApiService,
    private globalService: GlobalService
  ) {}
  

  ngOnInit() {

    this.populateBreadcrumb();
    //this.dashboardService.initRecap();
    this.dashboardService.initDashboard();
   
    this.getNews();
    this.getSegnalazioni();
 
    // this.buildChartOptions();

  
    
  } 
  

  private populateBreadcrumb() {
    this.translate.get('breadcrumb').subscribe(labels => {
      this.breadcrumbs = [
        { icon: 'fas fa-home', routerLink: '/dashboard' },
      ];
    });
  }

  private buildChartOptions(){
    let params={};
    this.apiService.get('home/ticketapertiperstruttura',params).subscribe(data => {
      let labels=[];
      let valori=[];
      data.Result.forEach((s)=>{
        labels.push(s['name']);
        valori.push(s['value']);
      });
      this.ticketapertiperstruttura={
        labels:labels,
        datasets:[
        {
          backgroundColor: "#3b82f6",
          borderColor: "#3b82f6",
          label:'Tickets aperti per struttura',
          data:valori
        }
        ]
        };
    });
    this.chartOption = {
      indexAxis: "y",
      backgroundColor:"#ffffff",
      "maintainAspectRatio": false,
      "aspectRatio": 0.8,
      "plugins": {
          "legend": {
              "labels": {
                  "color": "#495057"
              }
          }
      },
      "scales": {
          "x": {
              "axis": "x",
              "ticks": {
                  "color": "#6c757d",
                  "font": {
                      "weight": 500
                  },
                  "minRotation": 0,
                  "maxRotation": 50,
                  "mirror": false,
                  "textStrokeWidth": 0,
                  "textStrokeColor": "",
                  "padding": 3,
                  "display": true,
                  "autoSkip": true,
                  "autoSkipPadding": 3,
                  "labelOffset": 0,
                  "minor": {},
                  "major": {},
                  "align": "center",
                  "crossAlign": "near",
                  "showLabelBackdrop": false,
                  "backdropColor": "rgba(255, 255, 255, 0.75)",
                  "backdropPadding": 2
              },
              "grid": {
                  "color": "#dfe7ef",
                  "drawBorder": false,
                  "display": true,
                  "lineWidth": 1,
                  "drawOnChartArea": true,
                  "drawTicks": true,
                  "tickLength": 8,
                  "offset": false,
                  "borderDash": [],
                  "borderDashOffset": 0,
                  "borderWidth": 1,
                  "borderColor": "rgba(0,0,0,0.1)"
              },
              "type": "linear",
              "beginAtZero": true,
              "display": true,
              "offset": false,
              "reverse": false,
              "bounds": "ticks",
              "grace": 0,
              "title": {
                  "display": false,
                  "text": "",
                  "padding": {
                      "top": 4,
                      "bottom": 4
                  },
                  "color": "#666"
              },
              "id": "x",
              "position": "bottom"
          },
          "y": {
              "axis": "y",
              "ticks": {
                  "color": "#6c757d",
                  "minRotation": 0,
                  "maxRotation": 50,
                  "mirror": false,
                  "textStrokeWidth": 0,
                  "textStrokeColor": "",
                  "padding": 3,
                  "display": true,
                  "autoSkip": true,
                  "autoSkipPadding": 3,
                  "labelOffset": 0,
                  "minor": {},
                  "major": {},
                  "align": "center",
                  "crossAlign": "near",
                  "showLabelBackdrop": false,
                  "backdropColor": "rgba(255, 255, 255, 0.75)",
                  "backdropPadding": 2
              },
              "grid": {
                  "color": "#dfe7ef",
                  "drawBorder": false,
                  "offset": true,
                  "display": true,
                  "lineWidth": 1,
                  "drawOnChartArea": true,
                  "drawTicks": true,
                  "tickLength": 8,
                  "borderDash": [],
                  "borderDashOffset": 0,
                  "borderWidth": 1,
                  "borderColor": "rgba(0,0,0,0.1)"
              },
              "type": "category",
              "offset": true,
              "display": true,
              "reverse": false,
              "beginAtZero": false,
              "bounds": "ticks",
              "grace": 0,
              "title": {
                  "display": false,
                  "text": "",
                  "padding": {
                      "top": 4,
                      "bottom": 4
                  },
                  "color": "#666"
              },
              "id": "y",
              "position": "left"
          }
      },
      "responsive": true
  };
   
  }

  private getSegnalazioni(){
    let params= {id_user:this.globalService.loggedUser.id};

  
    let segninv=this.apiService.get('home/listasegnalazioniinv',params);
    
    
  
    forkJoin([ segninv]).subscribe(data => {
      this.listasegnalazioniinv=data[0].Result;
      this.listasegnalazioniinv.forEach((n)=>{
        if(n['stato']=='O'){
          n['stato']='Aperta';
        }
        if(n['stato']=='P'){
          n['stato']='In lavorazione';
        }
        if(n['stato']=='A'){
          n['stato']='Attesa Risposta';
        }
        if(n['stato']=='T'){
          n['stato']='Proposta';
        }
        if(n['stato']=='R'){
          n['stato']='Riaperta';
        }
        n['data_apertura']=moment(n['data_apertura']).format('DD/MM/YYYY');
      });
    
    }); 
  }
  
  updatenews($event){

    this.apiService.get('home/updatenews',$event).subscribe(data => {
      this.getNews();
    }); 
  }

  
  
  private getNews(){
    let params= {id_user:this.globalService.loggedUser.id};
    this.apiService.get('home/news2',params).subscribe(data => {
      this.listaNews=data.Result;
      this.listaNews.forEach((n)=>{
        n['severity']='info';
        if(n['WEBAPP']){
          if(n['WEBAPP']=='ass'){
            n['severity']='danger';
          }
          if(n['WEBAPP']=='gen'){
            n['severity']='info';
          }
          if(n['WEBAPP']=='doc'){
            n['severity']='warning';
          }
        }
        n['message']=n['TESTO'];
        n['data']=moment(n['D_INSERT']).format('DD/MM/YYYY');

      });
    }); 
  }

  goto(sign){
    let logInfo = JSON.parse(localStorage.getItem("logInfo"));
    
    let params={
      oper:7,
      id_sign:sign.id_sign
    }
    this.javarComponent.submitForm('sign/gestioneSegnalazioni/ServletSign','GET',params);
  }
  
  receiveMessageDocDaLeggere(event:any){
   
    this.countDocDaLeggere=event;
  }

  receiveMessageKPIRefresh(event:any){
    this.resfreshingKPI=event;
  }

}
